import React from "react";
import { Dropdown, DropdownItem, DropdownMenu } from "semantic-ui-react";

const DateFiltersDropdown = ({
  text,
  items,
  onChange,
  className,
  disabled,
}) => {
  return (
    <Dropdown text={text} className={className} disabled={disabled}>
      <DropdownMenu>
        {items.map(({ name, startDate, endDate }) => {
          return (
            <DropdownItem
              text={name}
              onClick={() => onChange(startDate, endDate)}
            />
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

export default DateFiltersDropdown;
